import { useAuthStore } from "@/stores/auth-store";
import { hasPermission, hasAnyPermission, type Permission } from "@/lib/permissions";

export function useAuth() {
  const store = useAuthStore();

  return {
    ...store,
    can: (permission: Permission) =>
      store.isPlatformAdmin || (store.role ? hasPermission(store.role, permission) : false),
    canAny: (permissions: Permission[]) =>
      store.isPlatformAdmin || (store.role ? hasAnyPermission(store.role, permissions) : false),
  };
}
